import React from 'react';

import Accordion from 'react-bootstrap/Accordion';

import AdminUpdateUserModal from './AdminUpdateUserModal';
import AdminDeleteUserModal from './AdminDeleteUserModal';

class AdminUserItem extends React.Component {
    constructor(props) {
	super(props);
	
	this.state = {
	    showUpdateUser: false,
	    showDeleteUser: false
	};

	this.handleSuccess = this.handleSuccess.bind(this);
	this.handleError = this.handleError.bind(this);
    }

    handleSuccess() {
	this.setState({
	    showUpdateUser: false,
	    showDeleteUser: false
	});

	this.props.onSuccess();
    }
    
    handleError() {
	this.setState({
	    showUpdateUser: false,
	    showDeleteUser: false
	});

	this.props.onError();
    }
    
    render() {
	var user = this.props.user;
	var email = "mailto:" + user.email;
	
	return (
	    <>
		<Accordion.Item eventKey={user.id}>
		    <Accordion.Header>{user.firstname} {user.lastname} &nbsp;&nbsp; <i>{user.team}</i></Accordion.Header>
		    <Accordion.Body>
			<table>
			    <tbody>
				<tr>
				    <td align="right"><b>Scoutk&aring;r:</b></td>
				    <td>{user.troop}</td>
				</tr>
				<tr>
				    <td align="right"><b>Email:</b></td>
				    <td><a href={email}>{user.email}</a></td>
				</tr>
				<tr>
				    <td align="right"><b>Kurs&aring;r:</b></td>
				    <td>{user.year}</td>
				</tr>
			    </tbody>
			</table>
			<img src="edit_user.png" alt="Uppdatera" className="pointer" onClick={() => this.setState({showUpdateUser: true})} />
			&nbsp;&nbsp;&nbsp;&nbsp;
			<img src="remove_user.png" alt="Radera" className="pointer" onClick={() => this.setState({showDeleteUser: true})} />
			&nbsp;&nbsp;&nbsp;&nbsp;
			<img src="send.png" alt="Bjud in" className="pointer" />
		    </Accordion.Body>
		</Accordion.Item>
		
		<AdminUpdateUserModal show={this.state.showUpdateUser}
				      user={user}
				      token={this.props.token}
				      onHide={() => this.setState({showUpdateUser: false})}
				      onSuccess={this.handleSuccess}
				      onError={this.handleError}
				      onAuthError={this.props.onAuthError}
		/>
		
		<AdminDeleteUserModal show={this.state.showDeleteUser}
				      user={user}
				      token={this.props.token}
				      onHide={() => this.setState({showDeleteUser: false})}
				      onSuccess={this.handleSuccess}
				      onError={this.handleError}
				      onAuthError={this.props.onAuthError}
		/>
	    </>
	);
    }
}

export default AdminUserItem;
